import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import pictures from 'assets/images/home/section_6/pictures.png';

export default function Home__section__6() {
    return (
        <main className="nv__section nv__section--no-margin   nv__hp__section__6">
            <section className="nv__section__container">
                <section className="section__block">
                    <div className="picture">
                        <Animated animation={'animate__fadeInLeft animate__delay-1s'}>
                            <img src={pictures} alt="pictures" />
                        </Animated>
                    </div>
                </section>
                <section className="section__block">
                    <Animated animation={'animate__fadeInRight animate__delay-2s'}>
                        <h1>Pongamos en alto</h1>
                    </Animated>
                    <Animated animation={'animate__fadeInRight animate__delay-3s'}>
                        <h3>El campo mexicano</h3>
                    </Animated>
                    <Animated animation={'animate__fadeInRight animate__delay-4s'}>
                        <p>y disfruta de grandes benéficos con tu aportación.</p>
                    </Animated>

                    <Animated animation={'animate__fadeInRight animate__delay-5s'}>
                        <p className="text-full">
                            <strong>¡Una visita que marcó la diferencia! </strong> <br />
                            Un cliente clave de Canadá quedó impresionado por la excelencia de
                            nuestros cultivos. Su interés en aprovechar toda nuestra producción fue
                            electrizante. Sin embargo, nos encontramos con un giro inesperado.
                        </p>
                    </Animated>
                </section>
                {/* <h1>
                    TE GUSTARÍA SER ATENDIDO <br />
                    POR UN EXPERTO FINANCIERO
                </h1>

                <p>Déjanos tus datos y en breve uno de nuestros expertos estará contigo.</p>

                <div className="contacFormBlock">
                    <ContactForm />
                </div> */}
            </section>
        </main>
    );
}
